export default __webpack_public_path__ + "static/media/white-plus-icon.21396a63.svg";